import React from 'react'
import Text from "../components/footer/Text"
import "../styles/css/footer.css"
const Footer = () => {
  return (
    <div className="container"><Text/></div>
  )
}

export default Footer